
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        itemPerRow: {
            type: Number,
            default: 5
        },
        autoColumn: {
            type: Boolean,
            default: true,
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['submit', 'reset'],
    setup(props, { emit }) {
        const onSubmit = () => {
            if (props.loading) return
            emit('submit')
        }

        const onReset = () => {
            if (props.loading) return
            emit('reset')
        }

        return {
            onSubmit,
            onReset
        }
    }
})
